import { render, staticRenderFns } from "./Parallax.vue?vue&type=template&id=15acad34&scoped=true"
import script from "./Parallax.vue?vue&type=script&lang=ts"
export * from "./Parallax.vue?vue&type=script&lang=ts"
import style0 from "./Parallax.vue?vue&type=style&index=0&id=15acad34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15acad34",
  null
  
)

export default component.exports